import { createAPI } from "../apisServer";

import BaseUrl from "../baseUrls";

const banco = BaseUrl.dataBase;
const apiServer = createAPI("urlAsaas");

const reqClientAsaas = {
	insert: async function (body) {
		return apiServer
			.post("asaas/v1/client", body, {
				headers: {
					banco: banco,
				},
			})

			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqClientAsaas;
